import { isPathMatches } from '@terminal/components/app-header/utils/navigation-utils';
import { TrackingMetadata } from '@terminal/services/tracking/posthog/constants';
import { useDocumentSearch } from '@terminal/views/alfred/document-search/use-document-search/useDocumentSearch';
import { useRef } from 'react';

import { ChatInputComposer } from '../chat-input-composer/ChatInputComposer';
import { ChatInputConfig } from '../types';
import { useChatInputHandlers } from './useChatInputHandlers';

export interface ChatInputProps {
  submitCallback?: (message?: string) => void;
  chatContext?: {
    documents?: string[];
    documentTypes?: string[];
    entityTags?: string[];
  };
  config?: ChatInputConfig;
  trackingMetadata?: TrackingMetadata;
}

export const ChatDocumentSearch = ({
  submitCallback,
  chatContext,
  config,
  trackingMetadata,
}: ChatInputProps) => {
  const inputRef = useRef<HTMLTextAreaElement>(null);

  const { isMessagePending, messages } = useDocumentSearch(state => ({
    isMessagePending: state.isMessagePending,
    messages: state.messages,
  }));

  const isTargetPage = isPathMatches(['alfred', 'chart']);
  const isLoading = isTargetPage && isMessagePending;

  const handlers = useChatInputHandlers({
    config,
    chatContext,
    submitCallback,
    isLoading,
    trackingMetadata,
  });

  return (
    <ChatInputComposer
      ref={inputRef}
      handlers={handlers}
      config={{
        ...config,
        isLoading,
      }}
      trackingMetadata={trackingMetadata}
      promptRefinementContext={{
        messageId: messages.at(-1)?.id,
      }}
    />
  );
};
